import { isEmail } from "../helpers/Utils";

export interface ISenderDetails {
    firstName: string;
    firstNameIsValid: boolean,
    lastName: string;
    lastNameIsValid: boolean,
    email: string;
    emailIsValid: boolean,
    phone: string;
    company: string;

    fullName: string;
    //isValid: () => boolean;
    //isValid(): boolean;
}

export class SenderDetailsModel implements ISenderDetails {
    firstName: string;
    firstNameIsValid: boolean;
    lastName: string;
    lastNameIsValid: boolean;
    email: string;
    emailIsValid: boolean;
    phone: string;
    company: string;

    fullName: string;

    constructor(
    ) {
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.phone = "";
        this.company = "";
        this.firstNameIsValid = true;
        this.lastNameIsValid = true;
        this.emailIsValid = true;

        this.fullName = "";
    }

    static validateModel(model: ISenderDetails): boolean {

        if (!model) return false;

        if (model.firstName?.trim()
            && model.lastName?.trim()
            && (model.email?.trim() && isEmail(model.email))) {
            model.firstNameIsValid = true;
            model.lastNameIsValid = true;
            model.emailIsValid = true;
            return true;
        }

        if (!model.firstName?.trim()) {
            model.firstNameIsValid = false;
        } else {
            model.firstNameIsValid = true;
        }

        if (!model.lastName?.trim()) {
            model.lastNameIsValid = false;
        } else {
            model.lastNameIsValid = true;
        }

        if (!model.email?.trim() || !isEmail(model.email)) {
            model.emailIsValid = false;
        } else {
            model.emailIsValid = true;
        }

        return false;
    } 

     //[obsolete: use static validateModel instead]
    isValid(): boolean {
        return SenderDetailsModel.validateModel(this);
    }
}